import React from 'react'
import { ReactComponent as AnimalFootprint } from '../../../assets/early/svg/AnimalFootprint.svg'
import { ReactComponent as AnalyticsIcon } from '../../../assets/early/svg/AnalyticsIcon.svg'
import { ReactComponent as StudentIcon } from '../../../assets/early/svg/StudentIcon.svg'
import { useTranslation } from 'react-i18next'

function InitSettings({ openChangeAvatars = () => {} }) {
    const { t } = useTranslation()
    // const openAnalytics = () => navigation.navigate('Analyze');
    // const openClassData = () => navigation.navigate('MyClasses');

    const openAnalytics = () => {}
    const openClassData = () => {}
    return (
        <div className="flex flex-col items-center ">
            <div className="px-10 pt-8 space-y-2.5 max-w-[800px] w-full">
                <button className="h-20 bg-[#413F5E] rounded-[15px] flex items-center justify-center space-x-2 w-full" onClick={openChangeAvatars}>
                    <AnimalFootprint className="w-5" />
                    <span className="text-white text-lg font-bold">{t('Change Avatars')}</span>
                </button>
                <button className="h-20 bg-[#413F5E] rounded-[15px] flex items-center justify-center space-x-2 w-full" onClick={openAnalytics}>
                    <AnalyticsIcon className="w-4" />
                    <span className="text-white text-lg font-bold">{t('Go to Class Analytics')}</span>
                </button>
                <button className="h-20 bg-[#413F5E] rounded-[15px] flex items-center justify-center space-x-2 w-full" onClick={openClassData}>
                    <StudentIcon className="w-4" />
                    <span className="text-white text-lg font-bold">{t('Browse emotion distribution')}</span>
                </button>
            </div>
        </div>
    )
}

export default InitSettings
